'use strict';

import Api from './../abstract'
import { APP_TOKEN_NAME } from '@/config'
import { getQueryStringPhase2 } from '@/utils'

export let GET_LIST_LOGS = (params, successCallback, errorCallback) => {
    let filter = params.payload.filter || null
    let sort = params.payload.sort || null
    let page = params.payload.page || null
    let search = params.payload.search || null
    let lang = params.payload.lang || null
    let url = `${process.env.VUE_APP_API_URL}/admin/logs?${getQueryStringPhase2(filter, sort, page, search, lang)}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };

    return new Api(url, 'get', successCallback, errorCallback, { headers })
};
export let GET_FILE_EXPORT = (params, successCallback, errorCallback) => {
    let filter = params.payload.filter || null
    let sort = params.payload.sort || null
    let search = params.payload.search || null
    let page = params.payload.page || null
    let lang = params.payload.lang || null
    let url = `${process.env.VUE_APP_API_URL}/admin/logs/csv?${getQueryStringPhase2(filter, sort, page, search, lang)}`;
    let headers = {
        Authorization: `Bearer ${localStorage.getItem(APP_TOKEN_NAME)}`
    };

    return new Api(url, 'get', successCallback, errorCallback, { headers })
};
